var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2H2.66667C2.29848 2 2 2.29848 2 2.66667V7.33333C2 7.70152 2.29848 8 2.66667 8H6C6.36819 8 6.66667 7.70152 6.66667 7.33333V2.66667C6.66667 2.29848 6.36819 2 6 2Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 2H10.0002C9.63197 2 9.3335 2.29848 9.3335 2.66667V4.66667C9.3335 5.03486 9.63197 5.33333 10.0002 5.33333H13.3335C13.7017 5.33333 14.0002 5.03486 14.0002 4.66667V2.66667C14.0002 2.29848 13.7017 2 13.3335 2Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 8H10.0002C9.63197 8 9.3335 8.29848 9.3335 8.66667V13.3333C9.3335 13.7015 9.63197 14 10.0002 14H13.3335C13.7017 14 14.0002 13.7015 14.0002 13.3333V8.66667C14.0002 8.29848 13.7017 8 13.3335 8Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.666H2.66667C2.29848 10.666 2 10.9645 2 11.3327V13.3327C2 13.7009 2.29848 13.9993 2.66667 13.9993H6C6.36819 13.9993 6.66667 13.7009 6.66667 13.3327V11.3327C6.66667 10.9645 6.36819 10.666 6 10.666Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.cc389c55cf389da1ef03103e65de85ba.svg";
export { ForwardRef as ReactComponent };